import { SideMenuItemType } from "./Types";
import HomeImage from "../assets/img/Dashboard_Icon.svg";
import Settings from "../assets/img/settings.png";
import BulkUpload from "../assets/img/Bulk_Upload_Icon.svg";
import DownloadReports from "../assets/img/Download_Report_Icon.svg";
import RoleMaster from "../assets/img/Role_Master_Icon.svg";
import UserAccess from "../assets/img/User_Access.svg";
import SyncDisabledIcon from '@mui/icons-material/SyncDisabled';

export const RABC: SideMenuItemType[] = [
  {
    title: "Dashboard",
    icon: HomeImage,
    route: "dashboard",
    permission: 'dashboard-tab'
  },
  {
    title: "Bulk Upload",
    icon: BulkUpload,
    route: "upload",
    permission: 'bulk-upload-tab'
  },
  {
    title: "Role Master",
    icon: RoleMaster,
    route: "role-master",
    permission: 'role-master-tab'
  },
  {
    title: 'User Access',
    icon: UserAccess,
    route: 'user-access',
    permission: 'user-access-tab'
  },
  {
    title: "Download Reports",
    icon: DownloadReports,
    route: "download-reports",
    permission: 'download-reports-tab'
  },
  {
    title: "BB Sync Failures",
    icon: SyncDisabledIcon,
    route: "sync-failures",
    permission: 'bb-sync-failures-tab'
  },
  {
    title: "Logout",
    icon: Settings,
    route: "setting",
  },
];

export const getRolePermission = (tokenPayload: any) => {
  const client_name = process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? ''
  const permissions = tokenPayload?.resource_access[client_name]?.roles;
  return permissions;
}

export const getRoleId = (tokenPayload: any) => {
  const groupName = tokenPayload?.groups;
  let groupList: any = [];
  let roleId = 0;
  if (groupName?.includes('/Employee Group') && groupName?.includes('/Employee Group/Grievance')) {
    if (groupName?.length > 2) {
      groupName?.forEach((group: any) => {
        group != '/Employee Group' && group != '/Employee Group/Grievance' && group?.includes('/Employee Group/Grievance/') && groupList?.push(group);
      });
      roleId = groupList?.includes('/Employee Group/Grievance/Super Admin') ? 3 :
        groupList?.includes('/Employee Group/Grievance/GRO') ? 1 :
          groupList?.includes('/Employee Group/Grievance/Agent') ? 2 :
            4;
      return { roleId: roleId, roleName: groupList.map((each: any) => each?.replace('/Employee Group/Grievance/', '')) };
    }
    else {
      return { roleId: -2, roleName: [] };
    }
  } else {
    return { roleId: -1, roleName: [] };
  }
}